import * as React from 'react';
import { clsx as cx } from 'clsx';

import * as styles from './Links.css';
import { ILegalDocumentLink } from '../../types/link';

interface ILinksProps {
  links: ILegalDocumentLink[];
  activeLink?: string;
  hideActive?: boolean;
}

export function Links({ links, activeLink, hideActive }: ILinksProps) {
  return (
    <>
      {links.map(link =>
        hideActive && link.link === activeLink ? null : (
          <a
            className={cx(styles['link'], { [styles['link-active']]: link.link === activeLink })}
            href={link.link}
            key={link.link}
          >
            {link.title}
          </a>
        ),
      )}
    </>
  );
}
